import { render } from "./BackButton.vue?vue&type=template&id=41f7eff3&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=41f7eff3&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f7eff3"]])

export default __exports__